import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PAYMENT_METHOD } from '../../../constants'
import { useTranslation } from 'react-i18next'
import { setTabletForm } from '../../../actions/orderActions'
import { paymentMethodsSupport as paymentMethodsSupportSelector } from '../../../selectors/restaurant'
import useDidMountEffect from '../../../hooks/useDidMountEffect'

import InputFill from '../../../components/form/InputFill'
import PaymentMethodGroup from '../../../components/common/PaymentMethodGroup'

import IconPaypalActive from '../../../assets/icons/IconPaypalActive'
import IconCashActive from '../../../assets/icons/IconCashActive'
import IconCashCard from '../../../assets/icons/IconCashCard'

const TabletForm = ({ handleSubmit }) => {
    const { t } = useTranslation()
    const tabletForm = useSelector(state => state.OrderReducer.tabletForm)
    const paymentMethodsSupport = useSelector(paymentMethodsSupportSelector)
    const dispatch = useDispatch()

    const [form, setForm] = useState({ ...tabletForm })
    const [errors, setErrors] = useState({})

    const fields = [
        {
            label: 'customerInfo.paymentMethod',
            name: 'paymentMethod',
            component: PaymentMethodGroup,
            props: {
                list: [
                    {
                        label: t('customerInfo.payment'),
                        options: [
                            paymentMethodsSupport.includes(PAYMENT_METHOD.CASH) && {
                                widthIcon: true,
                                label: t('customerInfo.cash'),
                                value: PAYMENT_METHOD.CASH,
                                icon: IconCashActive,
                                unCheckClass: 'payment-type-uncheck',
                            },
                            paymentMethodsSupport.includes(PAYMENT_METHOD.CASH_CARD) && {
                                widthIcon: true,
                                label: t('customerInfo.cash_card'),
                                value: PAYMENT_METHOD.CASH_CARD,
                                icon: IconCashCard,
                                unCheckClass: 'payment-type-uncheck',
                            },
                            paymentMethodsSupport.includes(PAYMENT_METHOD.PAYPAL) && {
                                widthIcon: true,
                                label: 'Paypal',
                                value: PAYMENT_METHOD.PAYPAL,
                                icon: IconPaypalActive,
                                unCheckClass: 'payment-type-uncheck',
                            },
                        ].filter(Boolean),
                    },
                    // {
                    //     label: t('customerInfo.paymentMethodGroupOnline'),
                    //     options: [
                    //         paymentMethodsSupport.includes(PAYMENT_METHOD.PAYPAL) && {
                    //             widthIcon: true,
                    //             label: 'Paypal',
                    //             value: PAYMENT_METHOD.PAYPAL,
                    //             icon: IconPaypalActive,
                    //             unCheckClass: 'payment-type-uncheck',
                    //         },
                    //     ].filter(Boolean),
                    // },
                ].filter(el => !!el.options.length),
                large: true,
            },
        },
    ]

    const handleInputChange = e => {
        const { name, value } = e.target

        setForm(prev => ({
            ...prev,
            [name]: value,
        }))
    }
    const clearErrorField = () => {}

    useDidMountEffect(() => {
        dispatch(setTabletForm(form))
    }, [form])

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {fields.filter(Boolean).map((field, index) => {
                    const Component = field.component || InputFill
                    return (
                        <div key={index} className="col-12 col-md-6">
                            <Component
                                id={`cusInfo-${field.name}`}
                                className="mt-6"
                                label={t(field.label)}
                                name={field.name}
                                value={form[field.name]}
                                error={errors[field.name]}
                                onChange={handleInputChange}
                                onFocus={() => clearErrorField(field.name)}
                                {...field.props}
                            />
                        </div>
                    )
                })}
            </div>
        </form>
    )
}

export default TabletForm
